import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

import { LibraryService } from '../providers/library.services';
import { Library } from "../../common/models/library";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class LibraryFromOrganizationResolver implements Resolve<Library> {
    constructor(
        private libraryService: LibraryService,
//        private _storage: ModelsStorage,
    ) { }

    public resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> {
        return this.libraryService.getByOrganizationCode(route.params['organizationCode']);
    }
}
